import { useLocation } from "react-router-dom"
import { API } from "../../constants/constants"
import dayjs from "dayjs"
import BaseRichtext from "../../components/common/BaseRichtext"
import BaseSubheadline from "../../components/common/BaseSubheadline"

export default function BlogPage() {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const eintrag = JSON.parse(decodeURIComponent(queryParams.get("eintrag") ?? ""))
    return (
        <section className="min-h-[70vh] flex flex-col items-center justify-center max-w-page w-full px-4 sm:p-8">
            <div className="w-full h-fit flex flex-col md:flex-row gap-8 justify-center items-center ">
                <div className="w-full md:w-1/2 flex items-center justify-center ">
                    <img
                        className="aspect-auto rounded-default max-h-[50vh] object-cover w-full"
                        src={API + eintrag.calenderArticleImage.url}
                        alt={eintrag.calenderArticleImage.description ?? eintrag.calenderArticleImage.name}
                    />
                </div>
                <div className="w-full md:w-1/2 my-auto ">
                    <p className="text-neutral">{dayjs(eintrag.calenderArticleDate).format("DD.MM.YYYY")}</p>
                    <BaseSubheadline label={eintrag.calenderArticleHeadline} customColor="#990000"/>
                    <BaseRichtext content={eintrag.calenderArticleText} classProps="text-neutral"/>
                </div>
            </div>
        </section>
    )
}
